export enum DeviceDinoCategory {
	AD4DRX = 'AD4D_RX',
	AD4QRX = 'AD4Q_RX',
	ADX5DRX = 'ADX5D_RX',
	ADTD = 'ADTD',
	ADTQ = 'ADTQ',
	ADXR = 'ADXR',
	AD8C = 'AD8C',
	AD600 = 'AD600',
	MCRAD = 'MCR_AD',
	MCRULXD = 'MCR_ULXD',
	JINJICH2 = 'JINJI_CH2',
	JINJICH4 = 'JINJI_CH4',
	JINJICH8 = 'JINJI_CH8',
	ULXD1RX = 'ULXD1_RX',
	ULXD2RX = 'ULXD2_RX',
	ULXD4RX = 'ULXD4_RX',
	ULXD4DWBRX = 'ULXD4D_WB_RX',
	ULXD4QWBRX = 'ULXD4Q_WB_RX',
	QLXD = 'QLXD',
	SLXD4RX = 'SLXD4_RX',
	SLXD4DRX = 'SLXD4D_RX',
	SLXD4DERX = 'SLXD4DE_RX',
	SLXD4ERX = 'SLXD4E_RX',
	SLXD4QERX = 'SLXD4QE_RX',
	SLXD4QEDANRX = 'SLXD4QE_DAN_RX',
	SBC220 = 'SBC220',
	CHBHENH = 'CH_BH_ENH',
	CHBHMBP = 'CH_BH_MBP',
	CHBHTT = 'CH_BH_TT',
	CHSBRC = 'CH_SBRC',
	SBC441 = 'SBC441',
	PSM1000TX = 'PSM1000_TX',
	AXT610 = 'AXT610',
	AD610 = 'AD610',
	ADX1TX = 'ADX1_TX',
	ADX2TX = 'ADX2_TX',
	ADX3TX = 'ADX3_TX',
	ADX2FDTX = 'ADX2FD_TX',
	ADX1MTX = 'ADX1M_TX'
}
